import {
    SAVE_SCAN,
    IS_SCAN_SAVED,
    UPDATE_SCAN,
    IS_SCAN_UPDATED,
    GET_SCAN_BY_ID,
    SET_SCAN_BY_ID,
    GET_ALL_SCANS,
    SET_ALL_SCANS,
    SET_FILTERS,
    SET_PAGINATION_DATA,
    GET_SCANS_EXCEL_EXPORT_FILE,
    SET_SCANS_EXCEL_EXPORT_FILE,
    DOWNLOAD_TEMPLATE,
    SET_TEMPLATE_DATA,
    UPLOAD_ASSETS,
    IS_ASSETS_UPLOADED
} from './MandAScanTypes'

const saveScan = (payload: any) => ({ type: SAVE_SCAN, payload })

const isScanSaved = (flag: any) => ({ type: IS_SCAN_SAVED, flag })

const updateScan = (payload: any) => ({ type: UPDATE_SCAN, payload })

const isScanUpdated = (flag: any) => ({ type: IS_SCAN_UPDATED, flag })

const getScanById = (id: number) => ({ type: GET_SCAN_BY_ID, id })

const setScanById = (scanById: any) => ({ type: SET_SCAN_BY_ID, scanById })

const getAllScans = (payload: any) => ({ type: GET_ALL_SCANS, payload})

const setAllScans = (allScans: any) => ({ type: SET_ALL_SCANS, allScans })

const setFilters = (filters: any) => ({ type: SET_FILTERS, filters })

const setPaginationData = (paginationData: any) => ({ type: SET_PAGINATION_DATA, paginationData })

const getScansExcelExportFile = (payload: any) => ({ type: GET_SCANS_EXCEL_EXPORT_FILE, payload })

const setScansExcelExportFile = (file: any) => ({ type: SET_SCANS_EXCEL_EXPORT_FILE, file })

const downloadTemplate = () => ({ type: DOWNLOAD_TEMPLATE })

const setTemplateData = (file: any) => ({ type: SET_TEMPLATE_DATA, file })

const uploadAssets = (payload: any) => ({ type: UPLOAD_ASSETS, payload })

const isAssetsUploaded = (flag: any) => ({ type: IS_ASSETS_UPLOADED, flag })


export {
    saveScan,
    isScanSaved,
    updateScan,
    isScanUpdated,
    getScanById,
    setScanById,
    getAllScans,
    setAllScans,
    setFilters,
    setPaginationData,
    getScansExcelExportFile,
    setScansExcelExportFile,
    downloadTemplate,
    setTemplateData,
    uploadAssets,
    isAssetsUploaded
}